import { z } from 'zod';

import { transformKeysToCamelCase } from 'utils/formatters/transform-snake-to-camel';

const Miners = z.object({
  product_id: z.number(),
  asset_name: z.string(),
  pool_id: z.number(),
  pool_name: z.string(),
  pool_type: z.string(),
  pool_link: z.string(),
  id: z.number(),
  coin: z.string(),
  operation_type: z.string(),
  starts_at: z.number(),
  efficiency: z.string(),
  price_per_kw: z.string(),
  number: z.string(),
  efficiency_group: z.string(),
  power_consumption: z.string(),
  total_hashrate: z.string(),
  total_power: z.string(),
  daily_total_fee: z.number(),
  daily_output: z.number().default(0),
});

export const AssetsResponseSchema = z
  .object({
    data: z.object({
      active: z.object({
        contracts: z.array(z.NEVER),
        miners: z.array(Miners),
      }),
      pending: z.object({
        contracts: z.array(z.NEVER),
        miners: z.array(Miners),
      }),
      disabled: z.object({
        contracts: z.array(z.NEVER),
        miners: z.array(Miners),
      }),
      freezed: z.object({
        contracts: z.array(z.NEVER),
        miners: z.array(Miners),
      }),
    }),
  })
  .transform(transformKeysToCamelCase)
  .transform((data) => {
    const activeMiners = data.data.active.miners.map((item) => ({
      ...item,
      status: 'active' as TMinersStatuses,
    }));
    const pendingMiners = data.data.pending.miners.map((item) => ({
      ...item,
      status: 'pending' as TMinersStatuses,
    }));
    const disabledMiners = data.data.disabled.miners.map((item) => ({
      ...item,
      status: 'disabled' as TMinersStatuses,
    }));
    const freezedMiners = data.data.freezed.miners.map((item) => ({
      ...item,
      status: 'freezed' as TMinersStatuses,
    }));

    return { data: [...activeMiners, ...pendingMiners, ...disabledMiners, ...freezedMiners] };
  });

export type TAssetsResponse = z.infer<typeof AssetsResponseSchema>;
export type TAssetsData = TAssetsResponse['data'];
export type TAssetsDataItem = TAssetsData[number];
export type TMinersStatuses = 'active' | 'pending' | 'disabled' | 'freezed';
